import { customError } from './../../static/strings'
export const parseError = (error: any) => {
  return {
    code: JSON.stringify(error?.data?.errorCode),
    httpCode: error?.httpCode,
    category: '',
    description: error?.data?.errorKey ? error?.data?.errorKey?.errorDescription : error?.message,
    details: '',
    timestamp: '',
  }
}

export const parsePaymentLinkError = (additionalError: any, error: any) => {
  if (additionalError !== undefined) {
    if (additionalError?.amount) {
      return additionalError?.amount
    } else if (additionalError?.description) {
      return additionalError?.description
    } else if (additionalError?.pushSmsTo) {
      return additionalError?.pushSmsTo
    } else if (additionalError?.pushEmailTo) {
      return additionalError?.pushEmailTo
    } else if (additionalError?.linkExpiryAt) {
      return additionalError?.linkExpiryAt
    } else if (additionalError?.invoice) {
      return additionalError?.invoice
    }
  } else {
    error?.data?.error?.message ?? customError.errorOccured
  }
}
